export default __webpack_public_path__ + "static/Averta-Extrabold-fb6444482c40ac275dca7fdeebf54a3e.woff2";